import React from "react";
import { Col, Modal, Row, Form } from "reactstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import {
  addAppleSMSLink,
  updateAppleSMSLink,
} from "../../../store/applesmslink/actions";
import { useDispatch } from "react-redux";

const schema = yup.object().shape({
  email: yup.string().max(100).required(),
  password: yup.string().max(100).required(),
  phone: yup.string().max(50).nullable(),
  publicurl: yup.string().max(500).required(),
});

export default function AddNew({
  modal_center,
  tog_center,
  setmodal_center,
  data,
}) {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: data.email || "",
      password: data.password || "",
      phone: data.phone || "",
      publicurl: data.publicurl || "",
    },
  });

  const onSubmit = (formData) => {
    if (Object.keys(data).length !== 0) {
      dispatch(updateAppleSMSLink({ ...formData, id: data.id }));
    } else {
      dispatch(addAppleSMSLink(formData));
    }
    if (!Object.keys(errors).length) {
      setmodal_center(false);
    }
  };

  return (
    <Modal
      isOpen={modal_center}
      toggle={() => {
        tog_center();
      }}
      centered
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0">
          {Object.keys(data).length !== 0 ? "Update" : "Add"} Apple SMS Link
        </h5>
        <button
          type="button"
          onClick={() => setmodal_center(false)}
          className="close"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-2">
            <Col md="6">
              <div className="field">
                <input
                  {...register("email")}
                  className={`form-control ${errors.email ? "is-invalid" : null}`}
                  type="email"
                />
                <span className="label">Enter email</span>
              </div>
            </Col>
            <Col md="6">
              <div className="field">
                <input
                  {...register("password")}
                  className={`form-control ${errors.password ? "is-invalid" : null}`}
                  type="text"
                />
                <span className="label">Password</span>
              </div>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col md="6">
              <div className="field">
                <input
                  {...register("phone")}
                  className={`form-control ${errors.phone ? "is-invalid" : null}`}
                  type="text"
                />
                <span className="label">Phone</span>
              </div>
            </Col>
            <Col md="6">
              <div className="field">
                <input
                  {...register("publicurl")}
                  className={`form-control ${errors.publicurl ? "is-invalid" : null}`}
                  type="text"
                />
                <span className="label">Url</span>
              </div>
            </Col>
          </Row>
          <div className="d-flex flex-wrap gap-2 justify-content-center">
            <button
              type="button"
              className="btn btn-lg btn-secondary"
              onClick={() => setmodal_center(false)}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-lg btn-primary">
              {Object.keys(data).length !== 0 ? "Update" : "Add New"}
            </button>
          </div>
        </Form>
      </div>
    </Modal>
  );
}
